<button mat-button [matMenuTriggerFor]="menu" class="menu">ADMIN</button>

<mat-menu #menu="matMenu">
  <button mat-button class="menu-item">
    <a class="user-roles-link" [href]="userRoleUrl"> USER ROLES </a>
  </button>
</mat-menu>
